module.exports = __webpack_public_path__ + "static/media/jamilet-figueroa.54d58c4d.jpg";